import {OnixRoleEnum} from "../enums/OnixRoleEnum";
import {ApplicationPacketEnum, UserQuery} from "../graphql-types";

export class UserInfoHelper {
    static HasRole(role: OnixRoleEnum, info?: UserQuery | null): boolean {
        if (info) {
            if (info.user?.userRoles) {
                return !!info.user.userRoles.find(
                    (f) => f.role?.name?.toLowerCase() === role.toLowerCase(),
                );
            }
        }
        return false;
    }

    static HasPacket(
        info: UserQuery | undefined,
        packet: ApplicationPacketEnum,
    ): boolean {
        if (
            info &&
            info.user?.companySettings?.applicationPackets &&
            info.user.companySettings.applicationPackets.length
        ) {
            const packets = info.user.companySettings.applicationPackets.map(
                (m) => m,
            );
            return !!packets.find((f) => f.packet === packet);
        }

        return false;
    }

    static HasAnyRole(info: UserQuery, ...roles: OnixRoleEnum[]): boolean {
        return !!roles.find((r) => this.HasRole(r, info));
    }

    static HasAnyPacket(
        userInfo: UserQuery | undefined,
        ...packets: ApplicationPacketEnum[]
    ): boolean {
        if (userInfo) {
            return !!packets.find((f) => this.HasPacket(userInfo, f));
        }
        return false;
    }
}
